export interface WhtIntentDraft {
  whtIncomeType: string | null;
  whtRate: string;
  whtBase: string;
}

const INCOME_TYPES = [
  { value: '', label: 'ไม่มี' },
  { value: 'SERVICE', label: 'ค่าบริการ/รับจ้างทำของ (3%)' },
  { value: 'RENT', label: 'ค่าเช่า (5%)' },
  { value: 'TRANSPORT', label: 'ค่าขนส่ง (1%)' },
];

export function WhtIntentFields({
  value,
  onChange,
}: {
  value: WhtIntentDraft;
  onChange: (v: WhtIntentDraft) => void;
}) {
  return (
    <div className="card" style={{ padding: 12, display: 'grid', gap: 8 }}>
      <div style={{ fontWeight: 600 }}>ภาษีหัก ณ ที่จ่าย (ระบุเจตนา)</div>
      <label className="meta">ประเภทเงินได้</label>
      <select
        className="select"
        aria-label="ประเภทเงินได้ หัก ณ ที่จ่าย"
        value={value.whtIncomeType ?? ''}
        onChange={(e) => onChange({ ...value, whtIncomeType: e.target.value || null })}
      >
        {INCOME_TYPES.map((t) => (
          <option key={t.value} value={t.value}>
            {t.label}
          </option>
        ))}
      </select>
      <label className="meta">อัตราหัก ณ ที่จ่าย (%)</label>
      <input
        className="input"
        aria-label="อัตราหัก ณ ที่จ่าย"
        inputMode="decimal"
        value={value.whtRate}
        onChange={(e) => onChange({ ...value, whtRate: e.target.value })}
      />
      <label className="meta">ฐานภาษี</label>
      <input
        className="input"
        aria-label="ฐานภาษี หัก ณ ที่จ่าย"
        inputMode="decimal"
        value={value.whtBase}
        onChange={(e) => onChange({ ...value, whtBase: e.target.value })}
      />
      <div className="meta" style={{ color: 'var(--warning)' }}>
        บันทึกเป็นเจตนาเท่านั้น — ระบบจะออกหนังสือรับรองตอนจ่ายเงิน (ผ่านโมดูล WHT)
      </div>
    </div>
  );
}
